import React from "react";

export default function Compatibility() {
  return <div>Compatibility</div>;
}
